/**
 * guarantee-notice.js — <guarantee-notice>, the EU legal guarantee notice under the buy box.
 *
 * The notice (Regulation 2025/1960) is an A4 page that must be legible at its default size, which
 * the buy box column is not. The markup is a link to the official file, so without JS the visitor
 * gets the notice full size in a new tab. With JS the same link opens the file in a dialog sized to
 * read it, and the image is only requested then.
 */
(() => {
  if (customElements.get('guarantee-notice')) return;

  class GuaranteeNotice extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('.guarantee-notice__open');
      this.dialog = this.querySelector('dialog');
      if (!this.link || !this.dialog) return;
      this.onClick = (event) => {
        event.preventDefault();
        const img = this.dialog.querySelector('img[data-src]');
        if (img && !img.getAttribute('src')) img.setAttribute('src', img.dataset.src);
        this.dialog.showModal();
      };
      this.link.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      if (this.link) this.link.removeEventListener('click', this.onClick);
    }
  }

  customElements.define('guarantee-notice', GuaranteeNotice);
})();
